"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorType = void 0;
var ErrorType;
(function (ErrorType) {
    ErrorType["SCHEMA_VALIDATION_ERROR"] = "SCHEMA_VALIDATION_ERROR";
    ErrorType["PATH_FINDER_ERROR"] = "PATH_FINDER_ERROR";
    ErrorType["QUOTE_ERROR"] = "QUOTE_ERROR";
    ErrorType["ROUTE_ERROR"] = "ROUTE_ERROR";
    ErrorType["BAD_REQUEST"] = "BAD_REQUEST";
    ErrorType["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    ErrorType["RATE_LIMIT"] = "RATE_LIMIT";
    ErrorType["MAINTENANCE"] = "MAINTENANCE";
    ErrorType["UNAUTHORIZED"] = "UNAUTHORIZED";
    ErrorType["INTERNAL_ERROR"] = "INTERNAL_ERROR";
})(ErrorType || (exports.ErrorType = ErrorType = {}));
//# sourceMappingURL=index.js.map